import React from "react";
import { useTranslation } from "react-i18next";

/** Filter users by name (case-insensitive substring). */
export function filterUsersByName(users, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return users || [];
  return (users || []).filter((u) => (u.name || "").toLowerCase().includes(q));
}

export default function EmployeeNameFilter({ value, onChange, testid = "employee-name-filter" }) {
  const { t } = useTranslation();
  return (
    <input
      type="search"
      className="form-control form-control-sm"
      style={{ width: 220 }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={t("common.search_employee_name")}
      data-testid={testid}
    />
  );
}
